import script from "./toggle-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./toggle-button.vue?vue&type=script&setup=true&lang=ts"

import "./toggle-button.vue?vue&type=style&index=0&id=5851dc3a&lang=scss"

const __exports__ = script;

export default __exports__